import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { DemographicsScreen } from '@/features/hr-reports/demographics-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/demographics')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: DemographicsScreenRoute,
})

function DemographicsScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <DemographicsScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/demographics', search: next })}
    />
  )
}
